import React, { useEffect, useState } from 'react'
import { motion, } from 'framer-motion';
import MainLayout from '../../shared/components/MainLayout'
import PricingPlans from './components/PricingPlans';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { PRODUCTS_CONFIG } from './constants';
import Button2 from '../../shared/components/button/Button2';
import { ArrowLeft } from 'lucide-react';

const DetailProductV3 = () => {
    const location = useLocation();
    const { tierBought, product } = location.state || {};
    const { appCode } = useParams();
    const navigate = useNavigate();
    const [selectedProduct, setSelectedProduct] = useState<any>();
    const [showPurchaseButton, setShowPurchaseButton] = useState(false);
    useEffect(() => {
        const isTenantUser = localStorage.getItem("isTenantUser");
        setShowPurchaseButton(isTenantUser !== "true");
    }, []);

    useEffect(() => {
        if (appCode) {
            const findProduct = Object.values(PRODUCTS_CONFIG).find(
                (p) => p.appCode === appCode
            );
            if (findProduct) {
                setSelectedProduct(findProduct);
            }
        }
    }, [appCode]);

    return (
        <MainLayout>

            <div className="w-full mt-3 mb-2 text-center">
                <div className="w-full mt-3 mb-9 text-left pl-4">
                    <Button2
                        title='Back'
                        icon={ArrowLeft}
                        iconPosition='left'
                        onClick={() => navigate('/private/productListV3')}
                    />
                </div>
                <motion.h1
                    initial={{ opacity: 0, y: -20 }}
                    animate={{ opacity: 1, y: 0 }}
                    className="text-4xl font-bold text-center mb-8 text-gray-800"
                >

                    {showPurchaseButton ? "Select your plan to " : "Information about "} {selectedProduct?.name}
                </motion.h1>
                <motion.p
                    initial={{ opacity: 0, y: -20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.2 }}
                    className="text-center text-gray-600 mb-12"
                >
                    {showPurchaseButton ? "Select the plan that best suits your needs and start growing your business today." : "Product features"}

                </motion.p>
            </div>
            <div className="flex items-center justify-center p-4">
                <PricingPlans selectedProduct={selectedProduct} tierBought={tierBought} product={product} />
            </div>
        </MainLayout>
    )
}

export default DetailProductV3